import { render, staticRenderFns } from "./recordInfo.vue?vue&type=template&id=4966bcc2"
import script from "./recordInfo.vue?vue&type=script&lang=js"
export * from "./recordInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports